import { FC, useState } from "react";
import { Collapse, MenuList } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SideBarItemType } from "@/types/view";
import { AppMenuItem, AppMenuItemProps } from "@/components/common";
import MenuItem from "./MenuItem";

type AppMenuListItemProps = AppMenuItemProps & {
  subItems: SideBarItemType[];
};

const MenuListItem: FC<AppMenuListItemProps> = props => {
  const { subItems, ...otherProps } = props;

  const [isExpanded, setIsExpanded] = useState(true);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <AppMenuItem onClick={handleClick} {...otherProps} endIcon={isExpanded ? <ExpandLess /> : <ExpandMore />} />
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <MenuList>
          {subItems.map(menuItem => (
            <MenuItem menuItem={menuItem} key={menuItem.key} sx={{ pl: 4 }} />
          ))}
        </MenuList>
      </Collapse>
    </>
  );
};

export default MenuListItem;
